// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"breadcrumbs_breadcrumbs__d-tH5","breadcrumb":"breadcrumbs_breadcrumb__S+Ud1"};